// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * AppearanceSelector — selector de estilo (skin) y color (paleta).
 * Usa solo variables del sistema de diseño, así que funciona igual en Classic
 * y en cualquier skin, en claro y en oscuro.
 */

.appearance-selector {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.ap-intro {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--text-muted);
}

.ap-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ap-group__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.ap-group__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--text-muted);
}

.ap-group__actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.ap-link {
  background: none;
  border: 0;
  padding: 2px 4px;
  font-size: 11.5px;
  font-family: inherit;
  color: var(--accent-l);
  cursor: pointer;
  border-radius: 6px;
}

.ap-link:hover {
  text-decoration: underline;
}

.ap-link.is-on {
  font-weight: 600;
}

.ap-grid {
  display: grid;
  gap: 12px;
}

.ap-grid--skins {
  grid-template-columns: repeat(auto-fill, minmax(134px, 1fr));
}

.ap-grid--palettes {
  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));
}

.ap-card {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 8px 8px 10px;
  background: none;
  border: 2px solid transparent;
  border-radius: 14px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.ap-card:hover {
  background: rgba(var(--accent-rgb), 0.07);
}

.ap-card.is-active {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.08);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.14);
}

.ap-card__name {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-primary);
}

.ap-card__tag {
  font-style: normal;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--accent);
  background: rgba(var(--accent-rgb), 0.16);
  padding: 1px 5px;
  border-radius: 999px;
}

.ap-card__tagline {
  font-size: 10.5px;
  line-height: 1.35;
  color: var(--text-muted);
}

.ap-hint {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}

/* ── Miniatura de skin: ventana con barra lateral, tarjetas y un botón ─── */
.ap-thumb {
  display: flex;
  height: 76px;
  overflow: hidden;
  border: 1px solid rgba(127, 127, 127, 0.22);
}

.ap-thumb__side {
  width: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-top: 7px;
  border-right: 1px solid;
}

.ap-thumb__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.ap-thumb__line {
  width: 8px;
  height: 2px;
  border-radius: 2px;
  opacity: 0.7;
}

.ap-thumb__main {
  flex: 1 1;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ap-thumb__card {
  flex: 1 1;
  border: 1px solid;
  padding: 4px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.ap-thumb__title {
  height: 4px;
  width: 58%;
  border-radius: 2px;
  opacity: 0.85;
}

.ap-thumb__title--short {
  width: 38%;
}

.ap-thumb__sub {
  height: 3px;
  width: 76%;
  border-radius: 2px;
  opacity: 0.45;
}

.ap-thumb__chip {
  height: 9px;
  width: 46%;
}

/* ── Miniatura de paleta: solo color ──────────────────────────────────── */
.ap-palette-thumb {
  display: flex;
  height: 52px;
  overflow: hidden;
  border: 1px solid rgba(127, 127, 127, 0.22);
}

.ap-palette-thumb__side {
  width: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding-top: 6px;
  border-right: 1px solid;
}

.ap-palette-thumb__dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

.ap-palette-thumb__line {
  width: 5px;
  height: 2px;
  border-radius: 2px;
}

.ap-palette-thumb__main {
  flex: 1 1;
  padding: 6px 5px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ap-palette-thumb__bar {
  height: 5px;
  width: 80%;
  border-radius: 3px;
}

.ap-palette-thumb__bar--short {
  width: 56%;
  height: 3px;
}

.ap-palette-thumb__btn {
  margin-top: auto;
  height: 9px;
  width: 52%;
  border-radius: 4px;
}

.ap-card--palette .ap-card__name {
  font-size: 11px;
  font-weight: 500;
}

/* ═══════════════════════════════════════════════════════════════════
   FONDO — miniatura de cada estilo y control de movimiento
   ═══════════════════════════════════════════════════════════════════ */

.ap-grid--backgrounds {
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}

/* La miniatura es una ventana en miniatura del fondo real: así se elige por lo
   que se ve, no por el nombre. */
.ap-bg-thumb {
  display: block;
  width: 100%;
  height: 64px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background-color: var(--slate-50);
  overflow: hidden;
  position: relative;
}

/* Aurora: las mismas tres manchas del fondo, con los tonos de la paleta. */
.ap-bg-thumb--aurora {
  background-image:
    radial-gradient(60% 70% at 16% 14%, var(--bg-blob-1), transparent 66%),
    radial-gradient(55% 65% at 88% 20%, var(--bg-blob-2), transparent 68%),
    radial-gradient(70% 80% at 62% 100%, var(--bg-blob-3), transparent 70%);
}

/* Malla: la rejilla tenue. */
.ap-bg-thumb--mesh::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, .06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, .06) 1px, transparent 1px);
  background-size: 12px 12px;
}

[data-base="light"] .ap-bg-thumb--mesh::after {
  background-image:
    linear-gradient(rgba(0, 0, 0, .07) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, .07) 1px, transparent 1px);
}

/* Liso: solo el color de fondo. */
.ap-bg-thumb--plain {
  background-image: none;
}

.ap-card--bg .ap-card__name {
  font-size: 12px;
}

/* ── Movimiento: control segmentado ─────────────────────────────── */

.ap-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ap-inline__label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ap-seg {
  display: inline-flex;
  padding: 3px;
  gap: 2px;
  border-radius: 10px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
}

.ap-seg__btn {
  padding: 5px 12px;
  border: 0;
  border-radius: 8px;
  background: none;
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.ap-seg__btn:hover:not(:disabled) {
  color: var(--text-primary);
  background: rgba(var(--accent-rgb), 0.1);
}

.ap-seg__btn.is-on {
  background: rgba(var(--accent-rgb), 0.18);
  color: var(--accent-l);
  font-weight: 600;
}

.ap-seg__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/components/AppearanceSelector.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uFAAuF;AACzF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wEAEwE;;AAExE;EACE,4DAA4D;AAC9D;;AAEA;iCACiC;AACjC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE;;;2EAGyE;AAC3E;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;yEAEuE;EACvE,0BAA0B;AAC5B;;AAEA;EACE;;mEAEiE;AACnE;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,sEAAsE;;AAEtE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/**\r\n * AppearanceSelector — selector de estilo (skin) y color (paleta).\r\n * Usa solo variables del sistema de diseño, así que funciona igual en Classic\r\n * y en cualquier skin, en claro y en oscuro.\r\n */\r\n\r\n.appearance-selector {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n}\r\n\r\n.ap-intro {\r\n  margin: 0;\r\n  font-size: 12.5px;\r\n  line-height: 1.55;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ap-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.ap-group__head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ap-group__label {\r\n  font-size: 10.5px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.09em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ap-group__actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.ap-link {\r\n  background: none;\r\n  border: 0;\r\n  padding: 2px 4px;\r\n  font-size: 11.5px;\r\n  font-family: inherit;\r\n  color: var(--accent-l);\r\n  cursor: pointer;\r\n  border-radius: 6px;\r\n}\r\n\r\n.ap-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.ap-link.is-on {\r\n  font-weight: 600;\r\n}\r\n\r\n.ap-grid {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.ap-grid--skins {\r\n  grid-template-columns: repeat(auto-fill, minmax(134px, 1fr));\r\n}\r\n\r\n.ap-grid--palettes {\r\n  grid-template-columns: repeat(auto-fill, minmax(78px, 1fr));\r\n}\r\n\r\n.ap-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  padding: 8px 8px 10px;\r\n  background: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-family: inherit;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.ap-card:hover {\r\n  background: rgba(var(--accent-rgb), 0.07);\r\n}\r\n\r\n.ap-card.is-active {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.14);\r\n}\r\n\r\n.ap-card__name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.ap-card__tag {\r\n  font-style: normal;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  padding: 1px 5px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.ap-card__tagline {\r\n  font-size: 10.5px;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.ap-hint {\r\n  margin: 0;\r\n  font-size: 11.5px;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Miniatura de skin: ventana con barra lateral, tarjetas y un botón ─── */\r\n.ap-thumb {\r\n  display: flex;\r\n  height: 76px;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(127, 127, 127, 0.22);\r\n}\r\n\r\n.ap-thumb__side {\r\n  width: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding-top: 7px;\r\n  border-right: 1px solid;\r\n}\r\n\r\n.ap-thumb__dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.ap-thumb__line {\r\n  width: 8px;\r\n  height: 2px;\r\n  border-radius: 2px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.ap-thumb__main {\r\n  flex: 1;\r\n  padding: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.ap-thumb__card {\r\n  flex: 1;\r\n  border: 1px solid;\r\n  padding: 4px 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 4px;\r\n}\r\n\r\n.ap-thumb__title {\r\n  height: 4px;\r\n  width: 58%;\r\n  border-radius: 2px;\r\n  opacity: 0.85;\r\n}\r\n\r\n.ap-thumb__title--short {\r\n  width: 38%;\r\n}\r\n\r\n.ap-thumb__sub {\r\n  height: 3px;\r\n  width: 76%;\r\n  border-radius: 2px;\r\n  opacity: 0.45;\r\n}\r\n\r\n.ap-thumb__chip {\r\n  height: 9px;\r\n  width: 46%;\r\n}\r\n\r\n/* ── Miniatura de paleta: solo color ──────────────────────────────────── */\r\n.ap-palette-thumb {\r\n  display: flex;\r\n  height: 52px;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(127, 127, 127, 0.22);\r\n}\r\n\r\n.ap-palette-thumb__side {\r\n  width: 13px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding-top: 6px;\r\n  border-right: 1px solid;\r\n}\r\n\r\n.ap-palette-thumb__dot {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.ap-palette-thumb__line {\r\n  width: 5px;\r\n  height: 2px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.ap-palette-thumb__main {\r\n  flex: 1;\r\n  padding: 6px 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.ap-palette-thumb__bar {\r\n  height: 5px;\r\n  width: 80%;\r\n  border-radius: 3px;\r\n}\r\n\r\n.ap-palette-thumb__bar--short {\r\n  width: 56%;\r\n  height: 3px;\r\n}\r\n\r\n.ap-palette-thumb__btn {\r\n  margin-top: auto;\r\n  height: 9px;\r\n  width: 52%;\r\n  border-radius: 4px;\r\n}\r\n\r\n.ap-card--palette .ap-card__name {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════\r\n   FONDO — miniatura de cada estilo y control de movimiento\r\n   ═══════════════════════════════════════════════════════════════════ */\r\n\r\n.ap-grid--backgrounds {\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n}\r\n\r\n/* La miniatura es una ventana en miniatura del fondo real: así se elige por lo\r\n   que se ve, no por el nombre. */\r\n.ap-bg-thumb {\r\n  display: block;\r\n  width: 100%;\r\n  height: 64px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background-color: var(--slate-50);\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* Aurora: las mismas tres manchas del fondo, con los tonos de la paleta. */\r\n.ap-bg-thumb--aurora {\r\n  background-image:\r\n    radial-gradient(60% 70% at 16% 14%, var(--bg-blob-1), transparent 66%),\r\n    radial-gradient(55% 65% at 88% 20%, var(--bg-blob-2), transparent 68%),\r\n    radial-gradient(70% 80% at 62% 100%, var(--bg-blob-3), transparent 70%);\r\n}\r\n\r\n/* Malla: la rejilla tenue. */\r\n.ap-bg-thumb--mesh::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, .06) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, .06) 1px, transparent 1px);\r\n  background-size: 12px 12px;\r\n}\r\n\r\n[data-base=\"light\"] .ap-bg-thumb--mesh::after {\r\n  background-image:\r\n    linear-gradient(rgba(0, 0, 0, .07) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(0, 0, 0, .07) 1px, transparent 1px);\r\n}\r\n\r\n/* Liso: solo el color de fondo. */\r\n.ap-bg-thumb--plain {\r\n  background-image: none;\r\n}\r\n\r\n.ap-card--bg .ap-card__name {\r\n  font-size: 12px;\r\n}\r\n\r\n/* ── Movimiento: control segmentado ─────────────────────────────── */\r\n\r\n.ap-inline {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ap-inline__label {\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.ap-seg {\r\n  display: inline-flex;\r\n  padding: 3px;\r\n  gap: 2px;\r\n  border-radius: 10px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.ap-seg__btn {\r\n  padding: 5px 12px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  background: none;\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.ap-seg__btn:hover:not(:disabled) {\r\n  color: var(--text-primary);\r\n  background: rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n.ap-seg__btn.is-on {\r\n  background: rgba(var(--accent-rgb), 0.18);\r\n  color: var(--accent-l);\r\n  font-weight: 600;\r\n}\r\n\r\n.ap-seg__btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
